import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import setUiMessage from '../../Utilities/Tostify';
import PatientSignPopup from './PatientSignPopup';
import { useSelector } from 'react-redux';
import Button from '../Button';

function GoalPlanViewPopup({
  patientId,
  appointmentId,
  visitId,
  close,
  treatId,
  reviewed,
  status,
  type,
  handleTreatPlanListReload = () => {},
}) {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [allData, setAllData] = useState(false);
  const [demodata, setDemodata] = useState(false);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [patSignPopup, setPatSignPopup] = useState(false);
  const [reloadListFlag, setReloadListFlag] = useState(false);
  //const [headerFooterInfo, setHeaderFooterInfo] = useState('');
  const goalPlanstatus = {
    1: 'In-progress',
    2: 'Completed',
    3: 'Closed',
    4: 'Deferred',
  };
  useEffect(() => {
    (async () => {
      try {
        if (patientId && appointmentId) {
          const response = await post(
            'api/patient/treatmentPlan/patientTreatmentPlan',
            {
              patientId: patientId,
              appointmentId: appointmentId,
              visitId: visitId,
              treatmentId: treatId,
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            setDemodata(response?.data?.demographics);
            setData(response?.data?.treatmentData);
            if (response?.data?.result_set?.status === '1') {
            } else {
            }
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, appointmentId, visitId, treatId, reload]);

  const handleReviewAndChange = () => {
    close();
    handleTreatPlanListReload();
    navigate(
      `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patientId}/${appointmentId}/${visitId}/${treatId}`,
    );
  };

  const handlPatientSignature = async (treatmentId) => {
    setPatSignPopup(true);
    // if (treatmentId) {
    //   try {
    //     const response = await post(
    //       'api/patient/treatmentPlan/savePatSignInDate',
    //       {
    //         patientId: patientId,
    //         treatmentId: treatmentId,
    //         staffUserId: user?.id,
    //       }
    //     );
    //     if (response?.status === 200) {
    //       setReload(!reload);
    //     }
    //   } catch (err) {
    //     setUiMessage('err', err.message);
    //   }
    // }
  };

  const handleSaveAndSine = async (treatmentId) => {
    if (treatmentId) {
      try {
        const response = await post(
          'api/patient/treatmentPlan/saveSignInDate',
          {
            treatmentId: treatmentId,
            staffUserId: user?.id,
            appId: appointmentId,
          },
        );
        if (response?.status === 200) {
          setReload(!reload);
          setReloadListFlag(true);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }
  };

  const handlePrint = async () => {
    try {
      const response = await post(
        'api/patient/treatmentPlan/getTreatmentPlanPdf',
        {
          patientId: patientId,
          appointmentId: appointmentId,
          visitId: visitId,
          treatmentId: treatId,
          allData: allData,
          staffUserId: user?.id,
        },
      );
      if (response?.status === 200) {
        if (response.data?.status === 'success') {
          const pdfUrl = response.data?.pdfFileName;
          var popupWindow = window.open(
            pdfUrl,
            '',
            'height=800px,width=750px,resizable=0,fullscreen=0,titlebar=0,menubar=0,toolbar=0,status=0,scrollbars=1',
          );

          popupWindow.onload = function () {
            popupWindow.focus();
            popupWindow.print();
          };
        } else if (response.data?.status === 'pdffail') {
          setUiMessage('err', 'PDF file not generated');
        } else {
          setUiMessage('err', 'Print failed.');
        }
      } else {
        setUiMessage('err', `Server error: ${response.status}`);
        console.error('Server error:', response);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr prgrs-nt-vw-popup">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">{'Treatment Plan'}</div>
          <Button
            variant="circle"
            onClick={() => {
              close();
              if (reloadListFlag) {
                handleTreatPlanListReload();
              }
            }}
          >
            X
          </Button>
        </div>

        <div className="main-contnr-bdy prgrs-nt-vw-bdy">
          <div className="smart-tag-bdy">
            <div className="smart-tag-bdy-rw">
              <span style={{ fontSize: '21px' }}>
                {demodata?.patientName} (#
                {demodata?.chartNo})
              </span>
            </div>
            <div className="smart-tag-bdy-rw">
              <span>
                {demodata?.age} {demodata?.gender}
                {demodata?.dob && (
                  <>
                    ,&nbsp;<b>DOB</b>:{demodata?.dob}
                  </>
                )}
              </span>
            </div>
            <div className="smart-tag-bdy-rw">
              <span>
                <b>Address:</b>
                {demodata?.address && (
                  <>
                    <b>Address:</b> {demodata?.address}
                  </>
                )}
              </span>
            </div>
            <div className="smart-tag-bdy-rw">
              <span>
                {demodata?.email && (
                  <>
                    <b>Email</b>: {demodata?.email}
                  </>
                )}
                {demodata?.phoneLabel && demodata?.phone && (
                  <>
                    ,&nbsp;<b>{demodata?.phoneLabel}</b>: {demodata?.phone}
                  </>
                )}
              </span>
            </div>
            <div className="smart-tag-bdy-rw">
              <span>
                {demodata?.race && (
                  <>
                    <b>Race</b>: {demodata?.race}
                  </>
                )}
                {demodata?.raceGroup && (
                  <>
                    ,&nbsp;<b>Race</b>: {demodata?.raceGroup}
                  </>
                )}
                {demodata?.ethincity && (
                  <>
                    ,&nbsp;<b>Race</b>: {demodata?.ethincity}
                  </>
                )}
                {demodata?.ethincityGroup && (
                  <>
                    ,&nbsp;<b>Race</b>: {demodata?.ethincityGroup}
                  </>
                )}
              </span>
            </div>
          </div>
          <div>
            <div className="cntnt-blk prgrs-vw-blk">
              <span
                className="left assmnt-nt-hdng flex-sec"
                style={{ marginTop: '25px' }}
              >
                Treatment Plan:
              </span>
              <div className="assmnt-nt-rw-lft demosec tp-top-sec-val">
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Provider:</span>
                  <span className="left assmnt-nt-val">
                    {data?.providerName}
                  </span>
                </div>
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Resource:</span>
                  <span className="left assmnt-nt-val">
                    {data?.resourceName}
                  </span>
                </div>

                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Date:</span>
                  <span className="left assmnt-nt-val">
                    {data?.review_date}
                  </span>
                </div>

                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Procedure :</span>
                  <span className="left assmnt-nt-val">{data?.procName}</span>
                </div>
                {/* <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Select Problem:</span>
                  <span className="left assmnt-nt-val">
                    <span
                      dangerouslySetInnerHTML={{ __html: data?.selectProblem }}
                    />
                  </span>
                </div> */}
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Review in:</span>
                  <span className="left assmnt-nt-val bold">
                    {data?.review_in} ({data?.review_date})
                  </span>
                </div>
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">
                    Treatment duration:
                  </span>
                  <span className="left assmnt-nt-val">
                    {data?.treatment_duration}
                  </span>
                </div>
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Treatment mode:</span>
                  <span className="left assmnt-nt-val">
                    {data?.treatment_mode}
                  </span>
                </div>
                <div className="assmnt-nt-rw">
                  <span className="left assmnt-nt-lbl">Start date:</span>
                  <span className="left assmnt-nt-val">{data?.start_date}</span>
                </div>
              </div>
            </div>
            <div className="cntnt-blk prgrs-vw-blk">
              <div className="left assmnt-nt-hdng">
                <span className="left">Problem:</span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-val width100">
                  <span
                    dangerouslySetInnerHTML={{ __html: data?.selectProblem }}
                  />
                </span>
              </div>
            </div>
            <div className="cntnt-blk prgrs-vw-blk">
              <div className="left assmnt-nt-hdng">
                <span className="left">Presenting Problem:</span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-val width100">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: data?.PresentingProblem,
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="cntnt-blk prgrs-vw-blk">
              <div className="left assmnt-nt-hdng">
                <span className="left">Behavior:</span>
              </div>
              <div className="assmnt-nt-rw">
                <span className="left assmnt-nt-val width100">
                  <span dangerouslySetInnerHTML={{ __html: data?.behavior }} />
                </span>
              </div>
              {/* <div className="assmnt-nt-rw clear5">
                <span className="left assmnt-nt-lbl">Treatment duration:</span>
                <span className="left assmnt-nt-val">
                  {data?.treatment_duration}
                </span>
              </div>
              <div className="assmnt-nt-rw clear5">
                <span className="left assmnt-nt-lbl">Treatment mode:</span>
                <span className="left assmnt-nt-val">
                  {data?.treatment_mode}
                </span>
              </div>
              <div className="assmnt-nt-rw clear5">
                <span className="left assmnt-nt-lbl">Start Date:</span>
                <span className="left assmnt-nt-val">
                  {data?.start_datestart_date}
                </span>
              </div> */}
            </div>
          </div>
          <br />
          <br />
          {allData?.goalData &&
            allData?.goalData.map((item, i) => (
              <div key={i} className="cntnt-blk prgrs-vw-blk">
                <div className="assmnt-nt-hdng">
                  <span className="hshtg-lnk">Goal #{i + 1}:</span>

                  <span className="clear-left maroon common-fontsize">
                    Added: {item?.goalAddedDate}
                  </span>
                  <span className="hshtg-lnk"></span>
                </div>
                <div className="assmnt-nt-rw med-value clear-bottom qfontsize14">
                  <span
                    dangerouslySetInnerHTML={{ __html: item?.goalDetail }}
                  />
                </div>
                {item?.objArr.map((obj, j) => (
                  <div
                    key={j}
                    className="width100 clear-bottom"
                    style={{ borderBottom: '0px dotted orange' }}
                  >
                    <div className="assmnt-nt-sbhdng">
                      <span className="assmnt-nt-rw tp-chld-hdng orange-txt">
                        Objective #{j + 1}:
                      </span>
                      <span className="assmnt-nt-rw normal">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: obj?.objDetail,
                          }}
                        />
                      </span>
                      <span className="tp-status-rw">
                        <span className="normal sec-colr width100">
                          Added: {obj?.objAddedDate}
                        </span>
                        <span className="normal clear-right clear-left sec-colr width100 ">
                          Status: {goalPlanstatus[obj?.objStatus]}
                        </span>
                        <span className="normal clear-right clear-left sec-colr width100">
                          Completion:&nbsp;
                          <span
                            dangerouslySetInnerHTML={{
                              __html: obj?.completionDate,
                            }}
                          />
                        </span>
                      </span>
                    </div>
                    {obj?.interDetailArr.map((inter, k) => (
                      <div key={k} className="assmnt-nt-sbhdng">
                        <span className="assmnt-nt-rw tp-chld-hdng orange-txt">
                          Intervention #{k + 1}
                        </span>
                        <span className="assmnt-nt-rw normal">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: inter?.intervention_title,
                            }}
                          />
                        </span>
                        <span className="tp-status-rw">
                          <span className="normal sec-colr">
                            Added: {inter?.addedDateIntervention}
                          </span>
                        </span>
                      </div>
                    ))}
                    {obj?.reviewDetailArr.map((rev, l) => (
                      <div key={l} className="assmnt-nt-sbhdng">
                        <span className="assmnt-nt-rw tp-chld-hdng orange-txt">
                          Review #{l + 1}
                        </span>
                        <span className="assmnt-nt-rw normal">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: rev?.review_title,
                            }}
                          />
                        </span>
                        <span className="tp-status-rw">
                          <span className="normal sec-colr">
                            Added: {rev?.addedDateReview}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
        </div>
        <div
          style={{ marginLeft: '10px' }}
          dangerouslySetInnerHTML={{ __html: allData?.getSignStr }}
        />
        <span className="width100 flex-sec prgrs-nt-vw-btnrw">
          {(() => {
            if (type === '3') {
              if (reviewed === '1') {
                return (
                  <button
                    className="actn-yes width-unset"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                );
              } else {
                if (status === '2') {
                  return (
                    <>
                      <button
                        className="actn-No width-unset"
                        onClick={() => {
                          close();
                          if (reloadListFlag) {
                            handleTreatPlanListReload();
                          }
                        }}
                      >
                        Close
                      </button>
                      {!parseInt(allData?.result_set?.signin_by) &&
                      allData?.result_set?.resource_id === user?.id ? (
                        <button
                          className="actn-yes width-unset"
                          onClick={() =>
                            handleSaveAndSine(allData?.treatmentId)
                          }
                        >
                          Sign
                        </button>
                      ) : (
                        ''
                      )}
                      {parseInt(
                        allData?.cosign_result_set?.co_signin_status,
                      ) === 0 &&
                      allData?.result_set?.provider_id === user?.id &&
                      allData?.result_set?.resource_id !==
                        allData?.result_set?.provider_id ? (
                        <button
                          className="actn-yes width-unset"
                          onClick={() =>
                            handleSaveAndSine(allData?.treatmentId)
                          }
                        >
                          Co-Sign
                        </button>
                      ) : (
                        ''
                      )}
                      {!parseInt(allData?.result_set?.patient_sign_by) && (
                        <button
                          className={'actn-yes'}
                          style={{ width: 'unset' }}
                          onClick={() =>
                            handlPatientSignature(allData?.treatmentId)
                          }
                        >
                          Patient's Sign
                        </button>
                      )}
                      {
                        // !parseInt(allData?.result_set?.patient_sign_by) &&
                        !(
                          parseInt(allData?.result_set?.patient_sign_by) &&
                          parseInt(allData?.result_set?.signin_by)
                        ) ? (
                          <button
                            className="actn-yes width-unset"
                            onClick={handleReviewAndChange}
                          >
                            Change
                          </button>
                        ) : (
                          ''
                        )
                      }
                      {parseInt(allData?.result_set?.patient_sign_by) &&
                      parseInt(allData?.result_set?.signin_by) ? (
                        <button
                          className="actn-yes width-unset"
                          onClick={handleReviewAndChange}
                        >
                          Review treatment plan
                        </button>
                      ) : (
                        ''
                      )}

                      <button
                        className="actn-yes width-unset"
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </>
                  );
                } else if (status === '3' && reviewed !== '1') {
                  return (
                    <>
                      <button
                        className="actn-No width-unset"
                        onClick={() => {
                          close();
                          if (reloadListFlag) {
                            handleTreatPlanListReload();
                          }
                        }}
                      >
                        Close
                      </button>
                      {!parseInt(allData?.result_set?.patient_sign_by) && (
                        <button
                          className={'actn-yes'}
                          style={{ width: 'unset' }}
                          onClick={() =>
                            handlPatientSignature(allData?.treatmentId)
                          }
                        >
                          Patient's Sign
                        </button>
                      )}
                      {!(
                        parseInt(allData?.result_set?.patient_sign_by) &&
                        parseInt(allData?.result_set?.signin_by)
                      ) ? (
                        <button
                          className="actn-yes width-unset"
                          onClick={handleReviewAndChange}
                        >
                          Change
                        </button>
                      ) : (
                        ''
                      )}

                      {parseInt(allData?.result_set?.patient_sign_by) &&
                      (parseInt(allData?.result_set?.signin_by) ||
                        parseInt(allData?.cosign_result_set?.co_signin_by)) ? (
                        <button
                          className="actn-yes width-unset"
                          onClick={handleReviewAndChange}
                        >
                          Review treatment plan
                        </button>
                      ) : (
                        ''
                      )}
                      <button
                        className="actn-yes width-unset"
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </>
                  );
                } else {
                  return (
                    <button
                      className="actn-yes width-unset"
                      onClick={handleReviewAndChange}
                    >
                      Save & Sign
                    </button>
                  );
                }
              }
            }
          })()}
        </span>
        {patSignPopup && (
          <PatientSignPopup
            handlePrint={handlePrint}
            handleClose={() => setPatSignPopup(false)}
            patientId={patientId}
            treatmentId={allData?.treatmentId}
            handleReload={() => setReload(!reload)}
            setReloadListFlagTrue={() => setReloadListFlag(true)}
            appId={appointmentId}
          />
        )}
      </div>
    </div>
  );
}

export default GoalPlanViewPopup;
